import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import * as moment from 'moment';

declare var $: any;
let that;

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {
  public qri: any = '';
  public owner: any = '';
  public store: any = '';
  public customer: any = '';
  public serial: any = '';
  public data: any = '';
  public product: any = '';
  public stamp_info_param: any;

  fields: any = [];
  now: any = '';
  isShowButton = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router) {
    that = this;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const data_params = JSON.parse(params.data);
      console.log('data_params', data_params)
      if (data_params.qri) {
        this.qri = data_params.qri;
      }
      if (data_params.product) {
        this.product = data_params.product;
      }
      if (data_params.store) {
        this.store = data_params.store;
      }
      if (data_params.owner) {
        this.owner = data_params.owner;
      }
      if (data_params.data) {
        this.data = data_params.data;
      }
      if (data_params.data) {
        this.customer = data_params.data.customer;
      }
      if (data_params.data) {
        this.serial = data_params.data.serial_id;
      }
      if (data_params.data) {
        console.log('sdfsdfsdf')
        this.stamp_info_param = data_params.data.stamp_info;
      } else {
        console.log('20030230230203')
      }
    });
    console.log('this.stamp_info', this.stamp_info_param)
    this.now = moment().format('DD/MM/YYYY');
    const form: any = this.data;
    const dataField = Object.keys(form.fields).map(x => form.fields[x])
    this.fields = dataField;
    document.title = 'Dịch vụ được cung cấp bởi công ty cổ phần iCheck';
    $('#container').css('border', '1px solid #c5b4b4');
    window.onafterprint = function () {
      that.isShowButton = true;
      $('#container').css('border', '1px solid #c5b4b4');
    }
  }

  print() {
    this.isShowButton = false;
    $('#container').css('border', 'none');
    setTimeout(() => {
      window.print()
    }, 100)
  }

  close() {
    this.router.navigate(['/evs/guarantee/logs'])
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/print/print.component.ts